export const BOOKING_ADMIN_PAGE_UI = 'BOOKING_ADMIN_PAGE_UI';
export const BOOKINGS_PAGE_UI = 'BOOKINGS_PAGE_UI';

export const GET_CONNECTED_BOOKINGS_UI = 'GET_CONNECTED_BOOKINGS_UI';
export const GET_TA_COMMISSIONS = 'GET_TA_COMMISSIONS';
export const GET_CO_COMMISSIONS = 'GET_CO_COMMISSIONS';

export const START_END_2_END_BOOKING_UI = 'START_END_2_END_BOOKING_UI';
